<template>
  <span :class="tintClass" class="whitespace-nowrap tabular-nums" style="font-size: 12px;" :title="tooltip">
    {{ display }}
  </span>
</template>

<script>
export default {
  name: "DateCell",
  props: {
    expiry: { type: Number, default: null },
    info: { type: Object, default: null },
    dueMode: { type: String, default: 'date' },
    kind: { type: String, default: 'due' },
  },
  computed: {
    dateStr() {
      if (!this.expiry) return '';
      const d = new Date(this.expiry * 1000);
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    },
    daysLabel() {
      if (!this.info) return '—';
      if (this.info.overdue) return `Past due ${this.info.daysOverdue}d`;
      if (this.info.daysUntil === 0) return 'Due today';
      if (this.info.dueSoon) return `Due in ${this.info.daysUntil}d`;
      if (this.info.date) return 'On schedule';
      return '—';
    },
    display() {
      if (this.kind === 'plain') {
        return this.expiry ? this.dateStr : '—';
      }
      if (!this.info || !this.info.date) return '—';
      if (this.dueMode === 'days') return this.daysLabel;
      return this.dateStr;
    },
    tintClass() {
      if (this.kind === 'plain') {
        return this.expiry ? 'text-secondary font-medium' : 'text-gray-400';
      }
      if (!this.info || !this.info.date) return 'text-gray-400';
      if (this.info.overdue) return 'text-red-600 font-semibold';
      if (this.info.dueSoon) return 'text-yellow-800 font-semibold';
      return 'text-secondary font-medium';
    },
    tooltip() {
      if (this.kind === 'plain') return this.expiry ? this.dateStr : '';
      if (!this.info || !this.info.date) return '';
      if (this.info.overdue) return `Past due ${this.info.daysOverdue} days · was ${this.dateStr}`;
      if (this.info.daysUntil === 0) return `Due today · ${this.dateStr}`;
      if (this.info.dueSoon) return `Due in ${this.info.daysUntil} days · ${this.dateStr}`;
      return this.dateStr;
    },
  },
};
</script>
